import {getLocation} from '../../../../api/check-in';
import {
  ErrorMessage,
  FormGroup,
  FormItemGroup,
  Input,
  RequireMarker,
} from '../../../../../../components/form-items';
import {debounce} from 'lodash';
import React from 'react';
import {useFormContext} from 'react-hook-form';
import {LocationFormField} from '../../types';
import {useClient} from '../../../../context/auth-context';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSpinnerThird} from '@fortawesome/pro-light-svg-icons';

const LocationAddress = function () {
  const {register, setValue, errors} = useFormContext<LocationFormField>();
  const [isFetching, setFetchStatus] = React.useState(false);
  const client = useClient();

  return (
    <FormGroup columnTemplates={1}>
      <div>
        <FormItemGroup>
          <label>
            地址
            <RequireMarker />
          </label>
          <div className={'relative grid grid-cols-1'}>
            <Input
              className={'!pr-4 !h-[26px]'}
              ref={register({
                required: '地址為必填',
              })}
              name={'address'}
              placeholder={'請輸入地址'}
              onChange={debounce(async e => {
                if (e.target.value === '') {
                  return;
                }
                setFetchStatus(true);
                try {
                  const {data} = await getLocation(client, e.target.value);
                  setValue('location.longitude', data.longitude);
                  setValue('location.latitude', data.latitude);
                } catch (error) {
                  setValue('location.longitude', '');
                  setValue('location.latitude', '');
                }
                setFetchStatus(false);
              }, 1500)}
              error={errors?.address?.message}
              disabled={isFetching}
            />
            {isFetching && (
              <FontAwesomeIcon
                icon={faSpinnerThird}
                pulse
                className={'absolute top-[10px] right-[5px]'}
              />
            )}
          </div>
          <ErrorMessage>{errors?.address?.message}</ErrorMessage>
          <div className={'mt-[10px] grid grid-cols-2 gap-x-[15px]'}>
            <div className={'flex flex-col'}>
              <Input
                className={'!h-[26px]'}
                placeholder={'緯度'}
                ref={register({required: '緯度為必填'})}
                name={'location.latitude'}
                error={errors?.location?.longitude?.message}
                type={'number'}
                disabled={isFetching}
                step={'any'}
              />
              <ErrorMessage>
                {errors?.location?.longitude?.message}
              </ErrorMessage>
            </div>
            <div className="flex flex-col">
              <Input
                className={'!h-[26px]'}
                placeholder={'經度'}
                ref={register({required: '經度為必填'})}
                name={'location.longitude'}
                error={errors?.location?.longitude?.message}
                type={'number'}
                disabled={isFetching}
                step={'any'}
              />
              <ErrorMessage>
                {errors?.location?.longitude?.message}
              </ErrorMessage>
            </div>
          </div>
          <p className="mt-[5px] mb-0">
            (如地址無法帶出正確的經緯度可自行修改)
          </p>
        </FormItemGroup>
      </div>
    </FormGroup>
  );
};

export default LocationAddress;
